/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
define(['../appContext', '../services/services', '../utils/tools'],
function (app, services, tools) {
    "use strict";

    var crs = {};

    const sizeLimit = 1000 * 1024 * 1024;

    crs.allClientRecords = new tools.dictionary();

    /**
     * Merge incoming records from the database service to local client records and
     * update any local record references with the values from the database.
     */
    crs.mergeRecords = function (forRecordTypeID, records, dropdownFlag) {
        if (dropdownFlag == null) { dropdownFlag = false; }
        var clientRecs = crs.allClientRecords.getVal(forRecordTypeID);
        if (clientRecs == null) {
            clientRecs = {
                recordType: forRecordTypeID,
                clientRecords: new tools.dictionary()
            }
            var rectype = app.dv.cache.recordTypes.allRecordTypes.getVal(forRecordTypeID);
            if (typeof (forRecordTypeID) == 'object') {
                crs.allClientRecords.add(rectype.RecordTypeID, clientRecs, forRecordTypeID.UID);
            }
            else {
                crs.allClientRecords.add(forRecordTypeID, clientRecs, rectype.UID);
            }
        }

        var retArr = []
        for (var i = 0, l = records.length; i < l; i++) {
            var rec = records[i], cr = clientRecs.clientRecords.getVal(rec.Record.RecordID);
            if (cr == null) {
                // if we have no local records, then there is no worries about overwriting local records.
                cr = crs.newClientRecord(rec);
                retArr.push(cr);
            }
            else {
                // the record already exists; we need to merge it with current records.
                var recUpdated = false;

                // check and update the code and status (if necessary)
                if (cr.Record.Code != rec.Record.Code && dropdownFlag == false) {
                    cr.Record.Code = rec.Record.Code;
                    recUpdated = true;
                }

                if (cr.Record.Status != rec.Record.Status && dropdownFlag == false) {
                    cr.Record.Status = rec.Record.Status;
                    recUpdated = true;
                }

                // when we are merging a drop down, we only create new values that don't already
                // exist - we do NOT want to merge values.
                if (mergeValues(cr, rec, dropdownFlag) == true || recUpdated == true) {
                    for (var locIndex = 0, il = cr.localRecords.length; locIndex < il; locIndex++) {
                        var r = cr.localRecords[locIndex]
                        // calling "updateUI()" will take care of all UI related updates and calculations.
                        r.updateUI();

                        //Commenting out as I am not sure we want other views that may be sharing this record to force a refresh based on a selection changed...EK
                        // if this is currently the selected record of its MVC, we need force a reset of the selected record.
                        // this takes care of detail views, sub grids, subordinate MVCs, etc.
                        //if (r == r.parentMVC.selectedRecord) {
                        //    app.dv.mvc.setSelectedRecord(r.parentMVC, r);
                        //}
                    }
                }
                retArr.push(cr);
            }
        }

        // internal function to merge values of client records.
        function mergeValues(localRecord, serviceRecord, dropdownFlag) {
            var valUpdated = false;
            //NOTE: if the local record has a value that the service record does not, can't merge it here...WR
            for (var i = 0, il = serviceRecord.Values.length; i < il; i++) {
                // this is happening because of a refresh or save, so the service value overrides the local one.
                var updated = false, updateValue = false, updateMetaData = false,
                    val = serviceRecord.Values[i],
                    cv = localRecord.clientValues.getVal(val.PropertyID);

                if (cv == null) {
                    // new value; just create new client value.
                    //NOTE: if we are creating it here, that means that we HAVE NOT created it in an MVC; nothing to merge...WR
                    cv = crs.newClientValue(val);
                    localRecord.clientValues.add(val.PropertyID, cv, val.UID);
                }
                else if (dropdownFlag == false) {
                    val = preParseValue(val);
                    // for each of the properties of the dynamicValue object, we need to update to the service data.
                    if (cv.dynamicValue.Value != val.Value && !(tools.isDate(cv.dynamicValue.Value) && tools.isDate(val.Value) && cv.dynamicValue.Value.toString() === val.Value.toString())) {
                        // we have found the value has changed; we need to see if any currently edited values
                        // are set to this new value and if so we need to remove the edited value.
                        // NOTE: if dynamicValue.Value and val.Value are both dates, they will always be not equal because they are different object instances...AM
                        cv.dynamicValue.Value = val.Value;
                        updateValue = true;
                        updated = true;
                    }
                    if (cv.dynamicValue.ValueMetadata != val.ValueMetadata) {
                        // we have found that this value metadata has changed; we need to see if any currently edited values
                        // are set to this new value and if so we need to remove the edited value.
                        cv.dynamicValue.ValueMetadata = val.ValueMetadata;
                        updateMetaData = true;
                        updated = true;
                    }
                    if (cv.dynamicValue.TimeZoneOffset != val.TimeZoneOffset) {
                        cv.dynamicValue.TimeZoneOffset = val.TimeZoneOffset;
                        updated = true;
                    }
                    if (cv.dynamicValue.TypeValueID != val.TypeValueID) {
                        cv.dynamicValue.TypeValueID = val.TypeValueID;
                        updated = true;
                    }
                    if (updated == true) {
                        if (updateValue == true) {
                            for (var j = 0, jl = cv.localValues.length; j < jl; j++) {
                                var gv = cv.localValues[j];
                                if (gv.dynamicValueEdit == null || gv.dynamicValueEdit.Value == val.Value) {
                                    gv.dynamicValueEdit = null;
                                }
                                // there is no edit to this value, or the edited value is identical; don't want to save it again.
                                gv.dynamicValue.Value = val.Value;
                                gv.dynamicValue.TimeZoneOffset = val.TimeZoneOffset;

                                //since we are updating the value outside of gridValue properties, need to explicitly update expression calculations.
                                app.dv.mvc.gridRecord.gridValue.recalcExpressions(gv);
                            }
                        }
                        if (updateMetaData == true) {
                            for (var j = 0, jl = cv.localValues.length; j < jl; j++) {
                                var gv = cv.localValues[j];
                                if (gv.dynamicValueEdit == null || gv.dynamicValueEdit.ValueMetadata == val.ValueMetadata) {
                                    gv.dynamicValueEdit = null;
                                }
                                // there is no edit to this value, or the edited value is identical; don't want to save it again.
                                gv.dynamicValue.ValueMetadata = val.ValueMetadata;
                                gv.dynamicValue.TimeZoneOffset = val.TimeZoneOffset;

                                //since we are updating the value outside of gridValue properties, need to explicitly update expression calculations.
                                app.dv.mvc.gridRecord.gridValue.recalcExpressions(gv);
                            }
                        }

                        cv.dynamicValue.Status = val.Status;
                        cv.dynamicValue._State = app.dv.types.EntityStates.Unmodified;
                        valUpdated = true;
                    }
                }
            }
            return valUpdated;
        }

        return retArr;
    };

    /**
     * Remove the specified local record from the client records references.
     * This will also remove client value references.
     *
     * If this is the last local record, remove the client record as well
     * for this record type.
     * @param localRecord {gridRecord} local reference to a grid record to remove from its client record.
     * @param localRecord {clientRecord} client record that has no local record references and the client record needs to be dropped.
     */
    crs.removeRecord = function (localRecord) {
        if (localRecord.typeName == null || localRecord.typeName !== "datavoke.entities.gridRecord") {
            // this is a client record; not a grid record. Check if we have local record references.
            if (localRecord.localRecords.length > 0) {
                // we do have local references, we do not want to remove this client record.
                return;
            }

            // there are no local records; remove it from our catalog.
            var recs = crs.allClientRecords.getVal(localRecord.Record.RecordTypeID);
            if (recs != null) { recs.clientRecords.remove(localRecord.Record.RecordID); }
        } else {
            // unregister each gridValue from its client value.
            var vals = localRecord.gridValues.Values;
            for (var j = 0, jl = vals.length; j < jl; j++) {
                var v = vals[j],
                    index = v.clientValue.localValues.indexOf(v);
                v.clientValue.localValues.splice(index, 1);
            }

            var rindex = localRecord.clientRecord.localRecords.indexOf(localRecord);
            localRecord.clientRecord.localRecords.splice(rindex, 1);
            if (localRecord.clientRecord.localRecords.length === 0) {
                var clientRec = crs.allClientRecords.getVal(localRecord.clientRecord.Record.RecordTypeID);
                clientRec.clientRecords.remove(localRecord.clientRecord.Record.RecordID);
            }
        }
    };

    crs.getRecordByRTandRID = function (forRecordTypeID, id) {
        var recSet = crs.allClientRecords.getVal(forRecordTypeID);
        if (recSet == null) { return null; }
        return recSet.clientRecords.getVal(id);
    };

    /**
     * Create a new client record object - record is {Record: <Record Entity>, Values: <Array of Dynamic Values> }
     * @param {object} record - Record entity object
     * @param {boolean} addToLibraryFlag - Flag to indicate if the newly created client record should be added to allClientRecords or not.
     * In the case of a pivot MVC, the generated client records SHOULD NOT be added.
     * @returns {*}
     */
    crs.newClientRecord = function (record, addToLibraryFlag) {
        if (addToLibraryFlag == null) { addToLibraryFlag = true; }
        // do we already have this client record?
        let clientRec = crs.allClientRecords.getVal(record.Record.RecordTypeID), cr;
        if (clientRec != null) {
            cr = clientRec.clientRecords.getVal(record.Record.RecordID);
        }

        if (cr == null) {
            // we don't have a client record; create one.
            cr = {};
        }

        // update/assign the record information.
        cr.Record = record.Record;

        // This is a stub to keep all references where this client record is used for gridRecords...AL
        if (cr.localRecords == null) { cr.localRecords = []; }
        if (cr.clientValues == null) { cr.clientValues = new tools.dictionary(); }

        record.Values.forEach((value) => {
            let cv = cr.clientValues.getVal(value.PropertyID);
            if (cv == null) {
                cr.clientValues.add(value.PropertyID, crs.newClientValue(value), app.dv.cache.properties.allProperties.getVal(value.PropertyID).UID);
            }
        });

        // get the dictionary of client records for this record type...
        if (clientRec == null) {
            // if it does not exist yet, create it.
            clientRec = {
                recordType: cr.Record.RecordTypeID,
                clientRecords: new tools.dictionary()
            };

            //crs.allClientRecords.add(clientRec.recordType, clientRec)
            let rectype = app.dv.cache.recordTypes.allRecordTypes.getVal(clientRec.recordType);
            if (typeof (clientRec.recordType) === 'object') {
                crs.allClientRecords.add(rectype.RecordTypeID, clientRec, clientRec.recordType.UID);
            }
            else {
                crs.allClientRecords.add(clientRec.recordType, clientRec, rectype.UID);
            }
        }
        // add this new client record to the dictionary if NOT for a pivot MVC.
        if (addToLibraryFlag) {
            clientRec.clientRecords.add(cr.Record.RecordID, cr, cr.Record.UID);
        }

        return cr;
    };

    crs.newClientValue = function (dv) {
        let cv = {};
        cv.localValues = []; // This is a stub to keep all references where this client value is used for gridValues...AL
        cv.dynamicValue = preParseValue(dv);
        return cv;
    };

    /**
     * Check if the value coming in is a DateTime or StaticDateTime; they are serialized differently
     * and we need to get the dates for them.
     * @param {object} value
     * @returns {DynamicValue}
     */
    function preParseValue(value) {
        let dv = app.dv.entities.DynamicValue.convertFrom(value);
        // Make the date time conversion here as we create the client side records IF this is created from the server (where object has not yet been parsed)...AL
        if ((dv.DataType === app.dv.types.PropertyDataType.DateTime ||
            dv.DataType === app.dv.types.PropertyDataType.StaticDateTime)
            && dv.Value != null && dv.Value !== "") {

            var d = new Date(dv.Value);
            d.tzOffset = d.getTimezoneOffset();

            dv.Value = d;

            dv.Value.addHours(d.tzOffset / 60);
        }

        return dv;
    }

    /**
     * Link one or more record IDs to a main record ID
     * @param {number} mainRecordID - The main record ID for the link
     * @param {Array<number>} linkRecordIDs - Array of record IDs to link with the main record ID
     * @param {Function} [callback = tools.noop] - callback function for completion of the batch
     */
    crs.createRecordsLink = function (mainRecordID, linkRecordIDs, callback = tools.noop) {

        let linkRequests = linkRecordIDs.length,
            linkResponses = 0,

            /**
             * Set up an object for the transmission data to the service call
             * @type {Object}
             */
            recordLinkData = {
                /**
                 * @type {string}
                 */
                Session: app.dv.cache.session.sessionGUID,
                /**
                 * @type {number}
                 */
                currentRecord: mainRecordID,
                /**
                 * @type {number}
                 */
                recordToLink: -1,
                /**
                 * @type {number}
                 */
                replaceLinksForRecordTypeID: 0
            };

        for (let i = 0, limit = linkRecordIDs.length; i < limit; i++) {
            recordLinkData.recordToLink = linkRecordIDs[i];
            services.call(services.endpoints.linkRecords, recordLinkData)
                .then((data) => {
                    if (++linkResponses === linkRequests) {
                        callback();
                    }
                })
                .catch((e) => {
                    app.browser.notifier.showToast("There was an issue creating record links. Please contact your system administrator.", 6000);
                    console.error(`There was an issue creating record links.  Error: ${(e && e.message) || e || "Unknown error"}`);
                    callback();
                });
        }
    };

    /**
     * Unlink all records IDs from the first array from the record IDs in the second array
     * @param {Array<number>} recordIDs1 - Array of record IDs to unlink from the IDs in the other array
     * @param {Array<number>} recordIDs2 - Array of record IDs to unlink from the IDs in the other array
     * @param {Function} [callback = tools.noop] - callback function for completion of the batch
     */
    crs.unLinkRecords = function (recordIDs1, recordIDs2, callback = tools.noop) {

        var unLinkRequests = 0,
            unLinkResponses = 0,
            recordUnLinkData = {
                Session: app.dv.cache.session.sessionGUID,
                Record1: null,
                Record2: null
            };

        if (recordIDs1.length === recordIDs2.length) {
            unLinkRequests = recordIDs1.length;
            for (let i = 0, limit = recordIDs1.length; i < limit; i++) {
                recordUnLinkData.Record1 = recordIDs1[i];
                recordUnLinkData.Record2 = recordIDs2[i];
                services.call(services.endpoints.unLinkRecords, recordUnLinkData)
                    .then((data) => {
                        if (++unLinkResponses === unLinkRequests) {
                            callback();
                        }
                    });
            }
        }
        else {
            for (let i = 0, iLimit = recordIDs1.length; i < iLimit; i++) {
                for (let j = 0, jLimit = recordIDs2.length; j < jLimit; j++) {
                    unLinkRequests++;
                    recordUnLinkData.Record1 = recordIDs1[i];
                    recordUnLinkData.Record2 = recordIDs2[j];
                    services.call(services.endpoints.unLinkRecords, recordUnLinkData)
                        .then((data) => {
                            if (++unLinkResponses === unLinkRequests) {
                                callback();
                            }
                        });
                }
            }
        }
    };

    crs.save = async function (forRecordTypeID, recsToSave, linkedRecordID, callback) {
        let recsSaveData = {
            Session: app.dv.cache.session.sessionGUID,
            RecordTypeID: forRecordTypeID,
            SaveReq: recsToSave,
            linkedRecordID: linkedRecordID
        };

        // check the size of the data - if it is too big, we can't guarantee that we will keep our connection.
        let dataString = JSON.stringify(recsSaveData);
        if (dataString.length > sizeLimit) {
            // we need to show this as an error; the user needs to clear and attempt to save again (in smaller chunks!)
            let msg = 'Data being saved is larger than allowable maximum of ' + (sizeLimit / 1024 / 1024).toFixed(2) + 'MB';
            console.warn(msg);
            callback(msg);
            return;
        }

        let message;
        try {
            let response = await services.call(services.endpoints.saveRecords, recsSaveData);
            // Merge the updated IDs back for any new records / values...AL
            message = crs.mergeSavedResults(forRecordTypeID, response);
        }
        catch (error) {
            if (message == null) {
                message = error;
            }
            console.warn(`Error attempting to save data to service: ${error.message}`);
        }

        if (callback != null) {
            callback(message);
        }
        return message;
    };

    // Function to merge back the saved values (apply any newly created IDs, and reset states)...AL
    crs.mergeSavedResults = function (forRecordTypeID, savedResults) {
        if (savedResults == null) { return;}
        // The saved results will be an array of {RecordsResults: ..., ValuesResults: [...]}...AL
        var currResult,
            currRecEsr,
            currRec,
            currNewTempVal,
            currValEsr;
        for (var i = 0, li = savedResults.length; i < li; i++) {
            currResult = savedResults[i];

            // First merge back the record object...AL
            currRecEsr = currResult.RecordResult;
            if (currRecEsr != null) {
                if (currRecEsr.ex != null) {
                    console.log(currRecEsr.ex.message);
                    // there was an exception; we need to let the calling routines know we could not save.
                    // since there was no save, there is nothing to merge...WR
                    return "Unable to save any records or values.";
                }

                // get the local record and use it.
                currRec = crs.getRecordByRTandRID(forRecordTypeID, currRecEsr.clientID);

                // if we no longer have a local client record, then the last MVC reference was already disposed of.
                // there is nothing to merge...WR
                if (currRec == null) { continue; }

                //Here, we handle an assigned serial number for record types that have unique serial numbers assigned to them...EK
                if (currResult.RecordResult.serial != null && currResult.RecordResult.serial > 0) {
                    var serialVal = currRec.clientValues.getVal(app.dv.cache.recordTypes.allRecordTypes.getVal(forRecordTypeID).Definition.SerialPropertyID);
                    if (serialVal != null) {
                        //Find all places (grid values) where this client value is being used, and update it's text property (trigger calcs) .. EK
                        //NOTE: this should only loop once; you can only create a new record in one view, but the loop is here as a failsafe.
                        for (var iLocal = 0; iLocal < serialVal.localValues.length; iLocal++) {
                            var localGridVal = serialVal.localValues[iLocal];
                            if (localGridVal.dynamicValue.Status == null) { localGridVal.dynamicValue.Status = 0; }
                            localGridVal.displayProperties.setText(currResult.RecordResult.serial);
                            localGridVal.dynamicValue.Value = localGridVal.dynamicValueEdit.Value;
                            //We need to set this as not dirty as the serial property has already been saved server-side...EK
                            localGridVal.dynamicValueEdit = null;
                            localGridVal.dynamicValue._State = app.dv.types.EntityStates.Unmodified;
                        }
                        serialVal.dynamicValue._State = app.dv.types.EntityStates.Unmodified;
                    }
                }

                if (currRec.Record._State === app.dv.types.EntityStates.Deleted) {
                    // If this record was deleted, then just remove it and continue to next iteration (we don't need to evaluate the child values - as they were removed as well)...AL
                    crs.allClientRecords.getVal(forRecordTypeID).clientRecords.remove(currRecEsr.clientID);
                    var list = currRec.localRecords;
                    for (var j = list.length - 1; j >= 0; j--) {
                        var r = list[j];
                        // make sure that this local record is removed from its MVC instance.
                        var gr = null;
                        if (r.parentMVC != null && !r.parentMVC.isDisposed) {
                            if (r.parentMVC.records.containsKey(currRec.Record.RecordID)) {
                                gr = r.parentMVC.records.remove(currRec.Record.RecordID);
                            }
                            // if this MVC did not have record, then it was already removed by the delete record action; don't need to do this for it.
                            if (gr != null) {
                                // refresh the MVC's records and view.
                                if (r.parentMVC.selectedRecord != null && r.parentMVC.selectedRecord.clientRecord.Record.RecordID === currRec.Record.RecordID) {
                                    r.parentMVC.gridController.selectedRecord = null;
                                    r.parentMVC.selectedRecord = null;
                                }
                                r.parentMVC.gridController.dataLoaded(r.parentMVC);
                                if (r.parentMVC.formController != null && !r.parentMVC.isDropDown) {
                                    r.parentMVC.formController.dataLoaded();
                                }
                            }
                        }
                        // the dispose will take care of our client record reference
                        // and the client value references of the grid values.
                        r.dispose();
                    }
                    //currRec.dispose();
                    continue;
                }

                if (currRecEsr.recordID != null && currRecEsr.recordID !== 0) {
                    //Assign the new record ID to the record object ... EK
                    currRec.Record.RecordID = currRecEsr.recordID;

                    //We have a new record ID assigned, ensure all values have it...EK
                    for (var v = 0, vl = currRec.clientValues.Values.length; v < vl; v++) {
                        currNewTempVal = currRec.clientValues.Values[v];
                        if (currNewTempVal.dynamicValue.RecordID !== currRec.Record.RecordID) {
                            currNewTempVal.dynamicValue.RecordID = currRec.Record.RecordID;
                        }
                    }

                    //Update the client records key in the dictionary with the assigned record ID, if this is a new ID.
                    if (currRecEsr.clientID !== 0 && currRecEsr.clientID !== currRecEsr.recordID) {
                        var recType = crs.allClientRecords.getVal(forRecordTypeID),
                            ki = recType.clientRecords.Keys.indexOf(currRecEsr.clientID);
                        recType.clientRecords.Keys.splice(ki, 1, currRec.Record.RecordID);

                        // update the MVC for all local records so that the MVC dictionary contains matching keys...WR
                        for (var u = 0, ul = currRec.localRecords.length; u < ul; u++) {
                            var r = currRec.localRecords[u];
                            if (r.parentMVC != null && !r.parentMVC.isDisposed) {
                                r.parentMVC.records.updateKey(currRecEsr.clientID, currRecEsr.recordID);

                                // if there are any listening MVCs that have this saved record as a linked record, they need to be updated also to the new ID.
                                if (r.parentMVC.selectedRecord != null && r.parentMVC.selectedRecord.clientRecord.Record.RecordID === currRecEsr.recordID) {
                                    var listeners = r.parentMVC.listeners;
                                    for (var x = 0, ux = listeners.length; x < ux; x++) {
                                        var m = listeners[x];
                                        if (m.linkedRecord != null && m.linkedRecord.clientRecord.Record.RecordID === currRecEsr.clientID) {
                                            m.linkedRecord.clientRecord.Record.RecordID = currRecEsr.recordID;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

                //Mark this record as unmodified so it isn't accounted for on another save...EK
                currRec.Record._State = app.dv.types.EntityStates.Unmodified;
            }

            // if this was only a record save, then there will be no value results to loop through...WR
            if (currResult.ValuesResults == null) { continue; }

            for (var j = 0, lj = currResult.ValuesResults.length; j < lj; j++) {
                // Now apply any value merges...AL
                currValEsr = currResult.ValuesResults[j];
                if (currValEsr != null) {
                    //TODO: update the client / property ID
                    var currVal = currRec.clientValues.getVal(currValEsr.propertyID);
                    if (currVal != null) {
                        if (currValEsr.newValue) {
                            // the server has transmitted a new value; this could be any server-generated value..WR
                            currVal.dynamicValue.Value = currValEsr.newValue;
                        }
                        if (currValEsr.valueID !== 0) {
                            //We had a new value inserted and a value ID assigned.. Update the value with this new ID... EK
                            currVal.dynamicValue.TypeValueID = currValEsr.valueID;

                            // if this new value is a product of a value copy,
                            if (currVal.dynamicValue.SourceTypeValueID != null) {
                                // remove the source type value id so it does not get copied again...WR
                                delete currVal.dynamicValue.SourceTypeValueID;
                            }
                        }

                        if (currValEsr.ex != null) {
                            var prop = app.dv.cache.properties.allProperties.getVal(currVal.dynamicValue.PropertyID),
                                msg = 'Unable to save value for property ' + ((prop && prop.Definition.Name) || currVal.dynamicValue.PropertyID)  + '; REFRESH to clear incorrect data.\n' + currValEsr.ex.message;
                            // there was an exception saving this value; let the client know.
                            console.warn(msg, currValEsr.ex);

                            // ensure the user sees the message (8 sec).
                            app.browser.notifier.showToast(msg, 8000, undefined, false);
                            continue;
                        }

                        for (var k = 0, kl = currVal.localValues.length; k < kl; k++) {
                            var gv = currVal.localValues[k];
                            if (gv.dynamicValueEdit != null) {
                                if (gv.dynamicValueEdit.Value === gv.dynamicValue.Value) {
                                    gv.dynamicValueEdit = null;
                                }
                            }
                            //We now need to notify this GV at this location that it needs to repaint (even if there was no pending edit) ... EK
                            gv.dynamicValue._State = app.dv.types.EntityStates.Unmodified;

                            // if this GridValue generated a value copy during the save,
                            if (gv.dynamicValue.SourceTypeValueID != null) {
                                // remove the source type value id so it does not get copied again...WR
                                delete gv.dynamicValue.SourceTypeValueID;
                            }

                            if (gv.parentRecord.parentMVC.primaryRecordType.Definition.CodePropertyID.UID === gv.property.UID) {
                                var gr = gv.parentRecord,
                                    gStatus = gv.getStatus(),
                                    rStatus = gr.getStatus();

                                if (gStatus.ValueStatusID !== rStatus.ValueStatusID) {
                                    // since status is different, it will update all grid values in the record.
                                    gv.parentRecord.setStatus(gv.getStatus());
                                }
                                else {
                                    // since the status is the same, we need to ensure all grid values match the status manually, just in case...WR
                                    gr.updateUI();
                                }
                            }
                            gv.updateUI();

                            //since we are updating the value outside of gridValue properties, need to explicitly update expression calculations.
                            app.dv.mvc.gridRecord.gridValue.recalcExpressions(gv);
                        }

                        currVal.dynamicValue._State = app.dv.types.EntityStates.Unmodified;
                    }
                }
            }
        }

        return null;
    };

    /**
     * Get records for the specified View or MVC, using defined or active criteria for filters, sorting, and page size.
     * @param {View|MVC} forView - The View entity object or MVC of the form that needs records for.
     * @param {Number|Null} linkedRecordID - (OPTIONAL) The record ID of the linked record
     * @param {Function} callback - Callback function to call with results.
     */
    crs.getView = function (forView, linkedRecordID, callback) {
        let postData = {
            Session: app.dv.cache.session.sessionGUID,
            viewReq: (forView.typeName === 'app.dv.mvc'
                // get the request based on the specified MVC.
                ? app.dv.cache.views.createReqFromMVC(forView)
                // get the request based on the specified view definition.
                : app.dv.cache.views.createReqFromDefinition(forView.Definition)),
            linkedRecordID: linkedRecordID
        };

        if (forView.typeName === 'app.dv.mvc') {
            // Do this before the callback, because drivingView will be null if the mvc closed during the service call.
            forView = forView.drivingView;
        }

        services.call(services.endpoints.getView, postData, function (r, e) {
            /**
             * NOTE: the "(forView.ViewID < 0)" parameter is a flag to let the merge know if these records were
             * pulled down for a drop-down list MVC (the view ID will be negative, or "< 0"). If it is, we do
             * NOT want to merge the client records in to overwrite statuses, codes, and values of the current
             * records because what we have locally should affect these coming down, not the other way around.
             */

            let mergedClientRecords = [], totalRecordCount = 0;

            if (r != null) {
                mergedClientRecords = crs.mergeRecords(forView.Definition.RecordTypeIDs[0], r.rdr, (forView.ViewID < 0));
                totalRecordCount = r.totalRecordCount;
            }
            else {
                app.browser.notifier.showToast("Unable to load data for " + forView.Definition.Name + " form, Please contact your system administrator.", 7522);
                console.error(`Failed to load data for: ${forView.Definition.Name}.  Error: ${(e && e.message) || e || "Unknown error"}`);
            }

            callback(mergedClientRecords, totalRecordCount);
        });
    };

    function saveRequest(record) {
        return {
            Record: record.clientRecord.Record,
            Values: record.gridValues.Values
        };
    }

    crs.getValueHistory = function (sessionGuid, typeValueID, dataType, callback) {
        if (callback == null) {
            //why would you call this function if you didn't want the data back?...TD
            return;
        }

        if (sessionGuid == null || typeValueID == null || dataType == null) {
            callback(null);
        }

        let postData = {
            Session: sessionGuid,
            DynamicValueID: typeValueID,
            ForType: dataType
        };

        services.call(services.endpoints.getByTypeValueID, postData, function (r, err) {
            callback(r, err);
        });

    };

    return crs;
});
